import React, { useEffect, useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import { SiGoogledrive, SiDropbox } from "react-icons/si";
import axios from "axios";
import API_BASE_URL from "../config";
import "../css/resumeUpload.css";

const ResumeUpload = () => {
  const [sessionData, setSessionData] = useState({ user_id: "", job_id: "" });

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/get-session`, { withCredentials: true })
      .then(response => {
        setSessionData(response.data);
      })
      .catch(error => {
        console.error("Failed to fetch session data:", error);
      });
  }, []);

  if (!sessionData.user_id || !sessionData.job_id) {
    return <div>Session expired. Please login again.</div>;
  }

  return (
    <div className="resume-container">
      <div className="resume-box">
        <div className="upload-icon">
          <FaCloudUploadAlt size={80} color="#a855f7" />
        </div>

        <h2>Add Your Resume</h2>

        <p style={{ marginBottom: "10px", fontWeight: "bold" }}>
          User ID: {sessionData.user_id} <br />
          Job ID: {sessionData.job_id}
        </p>

        <button className="upload-btn">
          <FaCloudUploadAlt style={{ marginRight: 8 }} />
          Upload My Resume or drop files here
        </button>

        <div className="cloud-options">
          <button className="cloud-btn">
            <SiGoogledrive style={{ marginRight: 8 }} />
            Upload From Google Drive
          </button>
          <button className="cloud-btn">
            <SiDropbox style={{ marginRight: 8 }} />
            Upload From Dropbox
          </button>
        </div>

        <p className="file-info">
          Supported file types are .doc, .docx, .pdf, .rtf, .txt <br />
          (Max size: 5 MB)
        </p>
      </div>
    </div>
  );
};

export default ResumeUpload;
